/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Patient_Mouse_CryInputs */

const fr_home_patient_mouse_cry = /** @type {(inputs: Home_Patient_Mouse_CryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tes dernières séances effectuées`)
};

/**

* @param {Home_Patient_Mouse_CryInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const home_patient_mouse_cry = /** @type {((inputs?: Home_Patient_Mouse_CryInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Patient_Mouse_CryInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_home_patient_mouse_cry(inputs)
});